// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function voidValidator(): ?UserInputValidationError {
  return VALID;
}
